<template>
	<page style="background: #fff;">
		<div v-html="content" class="agreement"></div>
	</page>
</template>

<script>
	export default {
		data() {
			return {
				content: ''
			}
		},

		mounted() {
			this.request({
				url: '/legal_agreement/app/detailByCode',
				data: {
					agreement_code: 'PRIVACY_POLICY'
				},
				success: data => {
					this.content = data.content;
				}
			});
		}
	}
</script>

<style lang="stylus" scoped>
	.agreement {
		padding: .4rem .32rem;
		line-height: .4rem;
		font-size: .28rem;
	}
</style>